import { PARTNER_ROUTER } from '@app/constant/RouterConstant'
import i18n from '@app/libs/language'
import theme from '@app/libs/theme'
import { Inertia } from '@inertiajs/inertia'
import { createInertiaApp } from '@inertiajs/inertia-react'
import { InertiaProgress } from '@inertiajs/progress'
import CloseIcon from '@mui/icons-material/Close'
import { IconButton } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { StylesProvider } from '@mui/styles'
import { SnackbarProvider } from 'notistack'
import NProgress from 'nprogress'
import { createRef } from 'react'
import { render } from 'react-dom'
import { I18nextProvider } from 'react-i18next'
import { QueryClient, QueryClientProvider } from 'react-query'
import PartnerLayout from './PartnerLayout'

const queryClient = new QueryClient()

const notistackRef = createRef()
const onClickDismiss = (key) => () => {
  notistackRef.current.closeSnackbar(key)
}

let currentUrl = ''

InertiaProgress.init({
  showSpinner: true,
})
Inertia.on('start', () => NProgress.start())
Inertia.on('finish', (event) => {
  if (event.detail.visit.completed) {
    NProgress.done()
  } else if (event.detail.visit.interrupted) {
    NProgress.set(0)
  } else if (event.detail.visit.cancelled) {
    NProgress.done()
    NProgress.remove()
  }
})

window.addEventListener('mousemove', (e) => {
  currentUrl = window.location.href
})

window.addEventListener('popstate', (event) => {
  if (currentUrl === route(PARTNER_ROUTER.LOGIN)) {
    event.stopImmediatePropagation()
    Inertia.reload({
      preserveState: true,
      preserveScroll: true,
      replace: true,
      onSuccess: (page) => Inertia.setPage(page),
      onError: () => (window.location.href = event.state.url),
    })
  }
})

createInertiaApp({
  resolve: async (name) => {
    const pages = import.meta.globEager(`./**/*.jsx`)
    const authPages = import.meta.globEager(`../Auth/**/*.jsx`)

    if (/^Auth\//.test(name)) {
      return authPages[`../${name}.jsx`]
    }

    const page = pages[`./${name}.jsx`].default
    if (page.layout === undefined) {
      page.layout = PartnerLayout
    }
    return page
  },
  setup({ el, App, props }) {
    render(
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <I18nextProvider i18n={i18n}>
            <StylesProvider>
              <SnackbarProvider
                action={(key) => (
                  <IconButton aria-label="close" color="inherit" size="small" onClick={onClickDismiss(key)}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )}
                anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                autoHideDuration={2000}
                maxSnack={4}
                ref={notistackRef}
              >
                <App {...props} />
              </SnackbarProvider>
            </StylesProvider>
          </I18nextProvider>
        </ThemeProvider>
      </QueryClientProvider>,
      el
    )
  },
})
